import React from 'react'
import { Icon, Table, } from 'semantic-ui-react'
import { FormikInputComponent, } from '../../../utilities/formUtils';
import { depositBankObj } from '../data/model';
import { Field } from 'formik'
import DepositBankArray from './depositBankArray';
import { useDispatch } from 'react-redux';
import { setAlertModalState } from '../../common/data/actions';

const CashBankMapArray = ({ name, move, swap, push, insert, unshift, remove, pop, form: { initialValues, values, errors },
    ...props }) => {

    const dispatch = useDispatch();
    let arrKeys = []
    const fieldName = name

    if (values[fieldName] && values[fieldName].length) {
        arrKeys = Object.keys(values[fieldName])
    }

    const getNewLineItem = (index) => {
        let numbering = depositBankObj()
        push(numbering)
    }

    const callToRemove = (index, remove) => {
        if (values[fieldName].length > 1) {
            remove(index);
        } else {
            dispatch(setAlertModalState({ isOpen: true, type: "error", size: "mini", title: "Warning", msg: 'You are not allowed to delete remaining last row' }));
        }
    }

    return (
        <>
            <Table basic='very' style={{ width: "90%", position: "reletive" }}>
                <Table.Body>
                    {
                        values[fieldName] && values[fieldName].length > 0 ? (
                            arrKeys.map((index) => (
                                <Table.Row key={`${fieldName}[${index}]`} style={{ padding: "0px", position: "relative" }}>
                                    <Table.Cell style={{ width: "18%", position: "relative" }}>
                                        <Field name={`${fieldName}[${index}].payment_mode`} component={FormikInputComponent} isLabel='false' isTxn='true' placeholder="Payment Mode" className="paymentModeField" />
                                    </Table.Cell>
                                    <Table.Cell style={{ width: "70%", position: "relative" }}>
                                        <Field name={`${fieldName}[${index}].deposit_bank_arr`} component={DepositBankArray} isLabel='false' isTxn='true' values={values}/>
                                    </Table.Cell>
                                    <Table.Cell style={{ width: "10%", paddingLeft: "4%", position: "relative" }} >
                                        <div style={{ position: "absolute", top: "10px" }}>
                                            <Icon title='Add Main Row' className="fontSizeAddDeleteIcon AddIcon" name='add' color='green' onClick={() => getNewLineItem(index)} style={{ cursor: 'pointer' }} />
                                            <Icon title='Delete Main Row' className="fontSizeAddDeleteIcon" name='cancel' color='red' onClick={(e) => callToRemove(index, remove)} style={{ cursor: 'pointer' }} />
                                        </div>
                                    </Table.Cell>
                                </Table.Row>
                            ))
                        ) : null
                    }
                </Table.Body>
            </Table>
        </>
    )
}

export default CashBankMapArray

